/** Datumswerte werden als ISO-8601-Strings gehalten. */

const DATE_FMT = new Intl.DateTimeFormat('de-AT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

/** ISO-String oder Date → "31.12.2026" */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return ''
  const d = typeof value === 'string' ? new Date(value) : value
  if (Number.isNaN(d.getTime())) return typeof value === 'string' ? value : ''
  return DATE_FMT.format(d)
}

/** Heutiges Datum als "YYYY-MM-DD". */
export function today(): string {
  return new Date().toISOString().slice(0, 10)
}

/** "YYYY-MM-DD" n Tage in der Zukunft. */
export function addDays(fromIsoDate: string, days: number): string {
  const d = new Date(fromIsoDate + 'T00:00:00Z')
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}

/** Aktuelles Jahr als Zahl. */
export function currentYear(): number {
  return new Date().getFullYear()
}
